export const getCurrentCompanyPending = (state) => state.permissions.current.pending
